import OnboardingUserV2 from '../components/OnboardingUserV2';
import UserInvitationV2 from '../components/UserInvitationV2';
import UserAutoEnrollmentV2 from '../components/UserAutoEnrollmentV2';
import Dashboard from '../views/Dashboard';
import ForgetPasswordV2 from '../views/ForgetPasswordV2';
import RecoverAccessV2 from '../views/RecoverAccessV2';
import LoginV2 from '../views/LoginV2';
import Maintenance from '../views/Maintenance';
import NotFoundPage from '../views/NotFoundPage';

interface ConfigRoutesI {
	path: string;
	component: React.ReactNode;
}

export const redirectRoutes: ConfigRoutesI[] = [
	{
		path: '/',
		component: <LoginV2 />
	}
];

export const publicRoutes: ConfigRoutesI[] = [
	{
		path: '*',
		component: <NotFoundPage />
	},
	{
		path: '/login',
		component: <LoginV2 />
	},
	{
		path: '/forget-password',
		component: <ForgetPasswordV2 />
	},
	{
		// Último recurso: quien no puede entrar NI recuperarse. Pública por lo mismo que
		// el endpoint que hay detrás — pedir sesión aquí sería pedir lo que no se tiene.
		path: '/recover-access',
		component: <RecoverAccessV2 />
	},
	{
		path: '/token',
		component: (
			<LoginV2 token={new URLSearchParams(window.location.search).get('token') || undefined} />
		)
	},
	{
		path: '/accept-user-invitation',
		component: <UserInvitationV2 />
	},
	{
		path: '/maintenance',
		component: <Maintenance />
	}
];

export const privateRoutes: ConfigRoutesI[] = [
	{
		path: '*',
		component: <NotFoundPage />
	},
	{
		path: '/dashboard/:tab',
		component: <Dashboard />
	},
	{
		path: '/onboarding-user',
		component: <OnboardingUserV2 />
	},
	{
		path: '/auto-enrollment',
		component: <UserAutoEnrollmentV2 />
	}
];
